import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useConfigQuery, useHallConfigQuery } from "../../../../api/payout";
import { useMemo } from "react";
import { PaymentListItem } from "../../Form/interface";
import { typeToText } from "../../functions";

interface PaymentsConfigProps {
    hall_id: number;
};

const PaymentsConfig = ({ hall_id }: PaymentsConfigProps) => {
    const { data: config } = useConfigQuery();
    const configMap = useMemo(() => {
        const configMap: { [key: number]: PaymentListItem } = {};
        if (!config) {
            return configMap;
        }
        config.data.forEach(item => configMap[item.id] = item);
        return configMap;
    }, [config])
    const { data: hallConfig } = useHallConfigQuery(hall_id);
    const paymentListItems = useMemo(() => {
        if (!hallConfig) {
            return [];
        }
        return hallConfig.data
            .slice()
            .sort((a, b) => a.payment_list_item_id - b.payment_list_item_id)
            .map(paymentListItemHall => {
                const method = configMap[paymentListItemHall.payment_list_item_id];
                if (!method) {
                    return null;
                }
                return <TableRow key={method.id}>
                    <TableCell>{method.id}</TableCell>
                    <TableCell>{method.is_withdraw ? "Вывод" : "Пополнение"}</TableCell>
                    <TableCell>{method.method}</TableCell>
                    <TableCell>{typeToText(method.type)}</TableCell>
                    <TableCell>{method.title}</TableCell>
                    <TableCell>
                        {method.options.batch && !!paymentListItemHall.batch && <div style={{ display: "flex", flexDirection: "column" }}>
                            <p>Время дозвона: {paymentListItemHall.batch.fullTime} сек</p>
                            <p>Интервал между запросами: {paymentListItemHall.batch.period} сек</p>
                        </div>}
                        {paymentListItemHall.min !== null && <div>Минимальная сумма: {paymentListItemHall.min}</div>}
                        {paymentListItemHall.max !== null && <div>Максимальная сумма: {paymentListItemHall.max}</div>}
                        {paymentListItemHall.mod !== null && <div>Кратность: {paymentListItemHall.mod / 100}</div>}
                        {paymentListItemHall.title !== null && <div>Заголовок: {paymentListItemHall.title}</div>}
                        {paymentListItemHall.caption !== null && <div>Подпись: {paymentListItemHall.caption}</div>}
                        {paymentListItemHall.bonus !== null && <div>Бонус: {paymentListItemHall.bonus}%</div>}
                        {paymentListItemHall.cancel_timer !== null && <div>Отмена через: {paymentListItemHall.cancel_timer} сек</div>}
                    </TableCell>
                </TableRow>;
            });
    }, [hallConfig, configMap]);
    return <Grid item xs={12} sm={12}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Направление</TableCell>
                    <TableCell>Провайдер</TableCell>
                    <TableCell>Тип</TableCell>
                    <TableCell>Заголовок</TableCell>
                    <TableCell>Настройки</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {paymentListItems}
            </TableBody>
        </Table>
    </Grid>
}

export default PaymentsConfig;